"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIMGNormalizedSource;
var _react = require("react");
var _SharedPropsProvider = require("../context/SharedPropsProvider");
function useIMGNormalizedSource(_ref) {
  var source = _ref.source,
    specifiedDimensions = _ref.specifiedDimensions;
  var cachedDimensions = (0, _react.useRef)(specifiedDimensions);
  var _ref2 = (0, _SharedPropsProvider.useSharedProps)(),
    provideEmbeddedHeaders = _ref2.provideEmbeddedHeaders;
  return (0, _react.useMemo)(function () {
    if (source.uri && typeof provideEmbeddedHeaders === 'function') {
      var _cachedDimensions$cur, _cachedDimensions$cur2;
      var headers = provideEmbeddedHeaders(source.uri, 'img', {
        printWidth: ((_cachedDimensions$cur = cachedDimensions.current) === null || _cachedDimensions$cur === void 0 ? void 0 : _cachedDimensions$cur.width) || undefined,
        printHeight: ((_cachedDimensions$cur2 = cachedDimensions.current) === null || _cachedDimensions$cur2 === void 0 ? void 0 : _cachedDimensions$cur2.height) || undefined
      });
      if (headers) {
        return _objectSpread({
          headers: headers
        }, source);
      }
    }
    return source;
  }, [provideEmbeddedHeaders, source]);
}